export const DOMAIN = 'on-running.com'
export const CUSTOMER_SERVICE_SUBDOMAIN = `customer-service.${DOMAIN}`
export const FILTER_PAGE_PATH = 'explore'
export const SIZE_GUIDE_PATH = 'size_guide'
export const SHIPPING_RETURNS_PATH = 'shipping_and_returns'
